/* LUMIVÉDA — DTC Brand JS */
(function () {
  'use strict';

  // ── Fade-in on scroll (IntersectionObserver — no scroll listener needed) ──
  var fades = document.querySelectorAll('.lv-fade');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    fades.forEach(function (el) { io.observe(el); });
  } else {
    fades.forEach(function (el) { el.classList.add('in'); });
  }

  // ── Sticky ATC: show after hero ──
  var hero   = document.querySelector('.lv-hero, .lv-home-hero');
  var sticky = document.getElementById('lv-sticky');
  if (hero && sticky) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(hero);
  }

  // ── Image gallery ──
  var mainImg = document.getElementById('lv-main-img');
  document.querySelectorAll('.lv-hero__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) mainImg.src = this.dataset.src;
      document.querySelectorAll('.lv-hero__thumb').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
    }, { passive: true });
  });

  // ── Bundle selector — variant ID + qty + sticky price sync ──

  function lvSyncSticky(opt) {
    if (!opt) return;
    var vid = opt.dataset.variantId;
    var qty = parseInt(opt.dataset.qty) || 1;

    // Hero form sync
    var heroVid = document.getElementById('lv-variant-id');
    var heroQty = document.getElementById('lv-quantity');
    if (heroVid && vid) heroVid.value = vid;
    if (heroQty) heroQty.value = qty;

    // Offer form sync
    var offerVid = document.getElementById('lv-offer-variant-id');
    var offerQty = document.getElementById('lv-offer-quantity');
    if (offerVid && vid) offerVid.value = vid;
    if (offerQty) offerQty.value = qty;

    // Sticky button variant sync
    var stickyBtnEl = document.getElementById('lv-sticky-btn');
    if (stickyBtnEl && vid) stickyBtnEl.dataset.variantId = vid;

    // Dynamic checkout form sync (Apple Pay / PayPal / Shop Pay)
    // Her bundle için ayrı form var (server-side render).
    // Doğru qty'nin formunu göster, diğerlerini gizle.
    [1, 2, 3].forEach(function (q) {
      var f = document.getElementById('lv-dynform-' + q);
      if (!f) return;
      var checkout = f.querySelector('.lv-dynamic-checkout');
      if (checkout) checkout.style.display = (q === qty) ? '' : 'none';
    });

    // Sticky price sync — read price from bundle opt DOM
    var priceNowEl  = opt.querySelector('.lv-bundle__opt-price-now');
    var priceWasEl  = opt.querySelector('.lv-bundle__opt-price-was');
    var priceSaveEl = opt.querySelector('.lv-bundle__opt-price-save');
    var stickyNow   = document.querySelector('.lv-sticky__price-now');
    var stickyWas   = document.querySelector('.lv-sticky__price-was');
    var stickySave  = document.querySelector('.lv-sticky__price-save');
    if (stickyNow && priceNowEl)  stickyNow.textContent  = priceNowEl.textContent.trim();
    if (stickyWas && priceWasEl)  stickyWas.textContent  = priceWasEl.textContent.trim();
    if (stickySave) {
      stickySave.textContent   = priceSaveEl ? priceSaveEl.textContent.trim() : '';
      stickySave.style.display = priceSaveEl ? '' : 'none';
    }
  }

  document.querySelectorAll('.lv-bundle__opt, .lv-offer__opt').forEach(function (opt) {
    opt.addEventListener('click', function () {
      var group = this.closest('.lv-bundle__options, .lv-offer__bundle-mini');
      if (group) group.querySelectorAll('.lv-bundle__opt, .lv-offer__opt').forEach(function (o) { o.classList.remove('selected'); });
      this.classList.add('selected');
      lvSyncSticky(this);
    });
  });

  // Init: sync sticky to the default selected bundle on page load
  var initSelected = document.querySelector('.lv-bundle__options .lv-bundle__opt.selected');
  if (initSelected) lvSyncSticky(initSelected);

  // ── FAQ accordion ──
  document.querySelectorAll('.lv-faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = this.closest('.lv-faq__item');
      var open = item.classList.contains('open');
      document.querySelectorAll('.lv-faq__item.open').forEach(function (i) { i.classList.remove('open'); });
      if (!open) item.classList.add('open');
    });
  });

  // ── Countdown timer — uses rAF to stay off main thread between ticks ──
  (function () {
    var key = 'lv_end';
    var end = parseInt(localStorage.getItem(key));
    if (!end || end < Date.now()) {
      end = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem(key, end);
    }
    function pad(n) { return n < 10 ? '0' + n : n; }
    var hEl = document.getElementById('lv-h');
    var mEl = document.getElementById('lv-m');
    var sEl = document.getElementById('lv-s');
    if (!hEl && !mEl && !sEl) return; // no timer on page, skip
    var lastSec = -1;
    function tick() {
      var now  = Date.now();
      var diff = Math.max(0, end - now);
      var sec  = Math.floor(diff / 1000);
      if (sec !== lastSec) {
        lastSec = sec;
        var h = Math.floor(sec / 3600);
        var m = Math.floor((sec % 3600) / 60);
        var s = sec % 60;
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }
      setTimeout(tick, 1000 - (now % 1000)); // sync to real second boundary
    }
    // Start timer in idle time so it doesn't block page load
    (window.requestIdleCallback || function(fn){ setTimeout(fn, 500); })(tick);
  })();

  // ── ATC buttons: delegated to cart drawer (lv-cart-drawer.liquid) ──
  // #lv-atc-btn, #lv-sticky-btn, #lv-offer-atc-btn are ALL intercepted by
  // the cart drawer's document click listener. No duplicate handler here.
  // The offer ATC button syncs its form values to hero form first via
  // the document listener in cart drawer.

  // Offer ATC: sync form values so cart drawer reads correct variant/qty
  var offerAtcBtn = document.getElementById('lv-offer-atc-btn');
  if (offerAtcBtn) {
    offerAtcBtn.addEventListener('click', function () {
      var offerVid = document.getElementById('lv-offer-variant-id');
      var offerQty = document.getElementById('lv-offer-quantity');
      var heroVid  = document.getElementById('lv-variant-id');
      var heroQty  = document.getElementById('lv-quantity');
      if (offerVid && heroVid) heroVid.value = offerVid.value;
      if (offerQty && heroQty) heroQty.value = offerQty.value;
      // Cart drawer intercepts this via document listener after this runs
    });
  }

  // ── "X ordered today" — dynamic number seeded by date so it's consistent
  //    within a day but changes daily (120–199 range)
  (function () {
    var el = document.getElementById('lv-ordered-today');
    if (!el) return;
    var today = new Date();
    var seed  = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate();
    var n     = 120 + (seed % 80); // 120-199
    el.textContent = '🔥 ' + n + ' ordered today';
  })();

  // ── Smooth scroll (anchor links) ──
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(this.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  // ── Mobile menu ──
  var hamburger = document.getElementById('lv-hamburger');
  var mobileNav = document.getElementById('lv-mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  // ── Multi-currency: Shopify Markets + Liquid | money handles all conversion server-side.
  // JS conversion removed — was causing discrepancy between live FX rate and Markets pricing.

})();
